import { ICategoryNameLocale, ICreateCategoryDTO } from '@/models/categories.model';
import { CreateCategoryFieldNames, EditCategoryFieldNames, TEditCategoryFormValues } from '../helpers/types';

class CreateCategoryDTO implements ICreateCategoryDTO {
  locale?: ICategoryNameLocale[];
  parent_id?: string;
  google_feed_id?: number;
  is_heavy?: boolean | null;
  photo?: File;

  constructor(values: TEditCategoryFormValues) {
    this.locale = values[EditCategoryFieldNames.LOCALE];
    this.google_feed_id = values[EditCategoryFieldNames.GOOGLE_FEED_ID];
    this.is_heavy = values[CreateCategoryFieldNames.IS_HEAVY] ? true : null;

    if (values[EditCategoryFieldNames.PARENT_ID]) {
      this.parent_id = values[EditCategoryFieldNames.PARENT_ID];
    }

    if (values[EditCategoryFieldNames.PHOTO]?.file?.originFileObj) {
      this.photo = values[EditCategoryFieldNames.PHOTO].file.originFileObj;
    }
  }
}

export default CreateCategoryDTO;
